/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
 window.filterCheck = () => {
    (function () {
  function waitForGlobo() {
    if (!window.globofilter || !globofilter.renderUI) {
      return setTimeout(waitForGlobo, 50);
    }

    const originalRenderUI = globofilter.renderUI;

    globofilter.renderUI = async function (data) {
      // Call original render
      const result = await originalRenderUI.apply(this, arguments);

      // ⏳ Wait for DOM paint
      requestAnimationFrame(() => {
        const products = history.state?.products || data?.products || [];

        if (typeof window.onGloboProductsRendered === 'function') {
          setTimeout(() => {
            window.onGloboProductsRendered(products);
          }, 500);
        }
      });

      return result;
    };

    console.log('✅ Globo renderUI patched successfully');
  }

  waitForGlobo();
})();



 window.onGloboProductsRendered = function (products) {
  
  if (!products || !products.length) return;

  products.forEach(product => {
    // ✅ Check tag
    if (!product.tags || !product.tags.includes('rylee40')) return;
    // 🔍 Find product card (Globo uses data-product-id)
    const card = document.querySelector(
      `.spf-product-card a[href*="/products/${product.handle}"]`
    )?.closest('.spf-product-card');

    if (!card) return;

    // ❌ Prevent duplicate badge
    if (card.querySelector('.custom-off-badge')) return;

    // 🏷 Create badge
    const badge = document.createElement('div');
    badge.className = 'custom-off-badge';
    badge.textContent = 'OFF 40%';
    // 📌 Inject inside card
    card.appendChild(badge);
  });
};

 }

 window.filterCheck();
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
   
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();
